/* ============================================================
   ADELE FOLLOW THE SUN — Scroll Animation Engine v3.1
   Mobile-first · Zero FOUC · Liquid-managed sections aware
   ============================================================ */
(function () {
  'use strict';

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const canHover      = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const isMobile      = () => window.innerWidth < 750;
  const raf           = fn => requestAnimationFrame(fn);
  const qs            = (s, c = document) => c.querySelector(s);
  const qsa           = (s, c = document) => [...c.querySelectorAll(s)];

  function initScrollAnimations() {
    if (reducedMotion) return;
    const vh = window.innerHeight;
    const sections = qsa('.shopify-section').filter(s =>
      !s.classList.contains('shopify-section--header') &&
      !s.classList.contains('shopify-section--footer')
    );

    raf(() => raf(() => {
      sections.forEach((section, i) => {
        const rect     = section.getBoundingClientRect();
        const belowFold = rect.top > vh * 0.75;

        if (i === 0 && rect.top < vh) return;

        const hasHardcoded = section.querySelector('[data-adele-anim]') !== null;

        if (!hasHardcoded && belowFold) {
          section.dataset.adeleAnim = 'up';
        }

        wireInnerAnimations(section, belowFold);
      });

      startObserver();
    }));
  }

  function wireInnerAnimations(section, belowFold) {
    function tag(el, type) {
      if (!el.dataset.adeleAnim) el.dataset.adeleAnim = type;
    }
    qsa('.image-with-text__media-wrapper', section).forEach(el => { if (belowFold) tag(el, 'scale'); });
    qsa('.image-with-text__content', section).forEach(el => { if (belowFold) tag(el, 'up'); });
    qsa('.multicolumn-list, .product-grid, .collection-list', section).forEach(el => { if (belowFold) tag(el, 'stagger'); });
    qsa('.rich-text__wrapper', section).forEach(el => { if (belowFold) tag(el, 'up'); });
  }

  let obs;
  function startObserver() {
    obs?.disconnect();
    obs = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        obs.unobserve(entry.target);
      });
    }, { threshold: 0.07, rootMargin: '0px 0px -24px 0px' });
    qsa('[data-adele-anim]').forEach(el => obs.observe(el));
  }

  function initHero() {
    if (reducedMotion) return;
    const banner = qs('.banner');
    if (!banner) return;
    qs('.banner__heading', banner)?.classList.add('adele-hero-heading');
    qs('.banner__text',    banner)?.classList.add('adele-hero-text');
    qs('.banner__buttons', banner)?.classList.add('adele-hero-cta');
  }

  function initParallax() {
    if (reducedMotion || isMobile()) return;
    const img = qs('.banner .banner__media img');
    if (!img) return;
    img.style.willChange = 'transform';
    const banner = img.closest('.banner');
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (ticking) return;
      raf(() => {
        const scrollY = window.scrollY;
        const bottom  = (banner?.getBoundingClientRect().bottom ?? 0) + scrollY;
        if (scrollY < bottom) img.style.transform = `translateY(-${scrollY * 0.12}px)`;
        ticking = false;
      });
      ticking = true;
    }, { passive: true });
  }

  function initCursor() {
    if (!canHover || reducedMotion) return;
    const dot = document.createElement('div');
    dot.className = 'adele-cursor';
    document.body.appendChild(dot);
    let mx = 0, my = 0, cx = 0, cy = 0, alive = false;
    document.addEventListener('mousemove', e => {
      mx = e.clientX; my = e.clientY;
      if (!alive) { alive = true; dot.classList.add('is-active'); loop(); }
    }, { passive: true });
    function loop() {
      cx += (mx - cx) * 0.14; cy += (my - cy) * 0.14;
      dot.style.left = cx + 'px'; dot.style.top = cy + 'px';
      raf(loop);
    }
    const H = 'a, button, .button, .card, label, input, select, [role="button"], .adele-tf__item';
    document.addEventListener('mouseover', e => { if (e.target.closest(H)) dot.classList.add('is-hovering'); }, { passive: true });
    document.addEventListener('mouseout',  e => { if (e.target.closest(H)) dot.classList.remove('is-hovering'); }, { passive: true });
    document.addEventListener('mousedown', () => dot.classList.add('is-clicking'), { passive: true });
    document.addEventListener('mouseup',   () => dot.classList.remove('is-clicking'), { passive: true });
  }

  function initRipple() {
    if (reducedMotion) return;
    document.addEventListener('click', e => {
      const btn = e.target.closest('.button');
      if (!btn) return;
      const r = btn.getBoundingClientRect();
      const size = Math.max(r.width, r.height) * 1.8;
      const el = document.createElement('span');
      el.className = 'adele-ripple';
      el.style.cssText = `width:${size}px;height:${size}px;left:${e.clientX-r.left-size/2}px;top:${e.clientY-r.top-size/2}px`;
      btn.appendChild(el);
      el.addEventListener('animationend', () => el.remove(), { once: true });
    });
  }

  function initImageFade() {
    const mark = img => img.classList.add('img-loaded');
    qsa('img').forEach(img => {
      img.complete ? mark(img) : img.addEventListener('load', () => mark(img), { once: true });
    });
    new MutationObserver(ms => ms.forEach(m => m.addedNodes.forEach(n => {
      if (n.tagName === 'IMG') { n.complete ? mark(n) : n.addEventListener('load', () => mark(n), { once: true }); }
      n.querySelectorAll?.('img').forEach(i => i.complete ? mark(i) : i.addEventListener('load', () => mark(i), { once: true }));
    }))).observe(document.body, { childList: true, subtree: true });
  }

  function initDesignMode() {
    if (!window.Shopify?.designMode) return;
    document.addEventListener('shopify:section:load',    () => setTimeout(initScrollAnimations, 100));
    document.addEventListener('shopify:section:reorder', () => setTimeout(initScrollAnimations, 100));
  }

  function boot() {
    initScrollAnimations();
    initHero();
    initParallax();
    initCursor();
    initRipple();
    initImageFade();
    initDesignMode();
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', boot, { once: true })
    : boot();

})();
